// extracted by mini-css-extract-plugin
module.exports = {"button":"AnnouncementsReopenButton_button__2TmnR","pulse":"AnnouncementsReopenButton_pulse__SPCjZ"};